export enum TYPE_SIDE {
  DURATION = 'duration',
  REPEATS = 'repeats',
}
